import { createApi } from '@reduxjs/toolkit/query/react';
import type { Institution, InstitutionAccess } from '../institutions.types';
import { ogBaseQuery } from '../../ogBaseQuery';

type LbInstitution = {
  institutionAccess: InstitutionAccess;
  id: number;
  domain: string;
  name: string;
  created: string;
};

export const institutionOGService = createApi({
  baseQuery: ogBaseQuery(),
  reducerPath: 'institutionOGReducerFromLibrary',
  endpoints: (builder) => ({
    getInstitutionByDomain: builder.query<
      Institution,
      { institutionDomain: string }
    >({
      query: (data) => {
        return {
          url: `institutions/findOne`,
          method: 'GET',
          params: {
            filter: JSON.stringify({
              where: { domain: data.institutionDomain },
              include: [
                'betaAccesses',
                'institutionAccess',
                'institutionMemberships',
                {
                  relation: 'purchases',
                  scope: {
                    where: { isActive: true },
                    limit: 1,
                  },
                },
              ],
            }),
          },
        };
      },
      transformResponse: (baseQueryReturnValue: LbInstitution): Institution => {
        return baseQueryReturnValue;
      },
    }),
    rememberInstitutionAuthState: builder.query<{}, { institutionId: string }>({
      // set 'transientAccessToken' cookie
      query: (data) => {
        return {
          url: `institutions/${data.institutionId}/rememberAuthState`,
          method: 'GET',
          // allow set cookie in the browser from  Set-cookie response header
          credentials: 'include',
        };
      },
    }),
  }),
});

export const {
  endpoints: { getInstitutionByDomain, rememberInstitutionAuthState },
  useGetInstitutionByDomainQuery,
  useLazyGetInstitutionByDomainQuery,
  useLazyRememberInstitutionAuthStateQuery,
} = institutionOGService;
